import React from 'react';
import { useTranslation } from 'react-i18next';
import { translateBookingStatus } from '../../../../utils/stranslateUltils';

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();

  return (
    <span className={`status-badge status-${status.toLowerCase()}`}>
      {translateBookingStatus(t,status)}
    </span>
  );
};

export default StatusBadge;